import React from 'react';
import Portal from "../../utils/Portal";

function AddCustomerPop(props) {
    return (
        <Portal>
            <div id="myModal" className="popup_box open">
                <div className="model_box">
                    <div
                        className="model_box_child thanksPopup"
                        id="customerAdded"
                        style={{ width: "320px" }}
                    >
                        {/*<div className="ap_heading">*/}
                        {/*    <h4>*/}
                        {/*        Assign a promo{" "}*/}
                        {/*        <span className="material-symbols-rounded black close_model">*/}
                        {/*            close*/}
                        {/*        </span>*/}
                        {/*    </h4>*/}
                        {/*</div>*/}
                        <div className="successCircle">
                            <i className="material-symbols-rounded white mt-xl fill">done</i>
                        </div>
                        <div className="contentSection">
                            <section>
                                <p className="mt-24">
                                    {props.message}
                                </p>
                            </section>
                            <div className="actionButtons mt-24">
                                <span>
                                    <a href="javascript:void(0);" className="btn prim" onClick={props.close}>
                                      Ok, thanks
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Portal>
    );
}

export default AddCustomerPop;